module.exports = __webpack_public_path__ + "static/media/scene5_sama1.34a3585d.wav";